import { render, staticRenderFns } from "./TrainingModelCard.vue?vue&type=template&id=0a54d0d3&scoped=true&"
import script from "./TrainingModelCard.vue?vue&type=script&lang=js&"
export * from "./TrainingModelCard.vue?vue&type=script&lang=js&"
import style0 from "./TrainingModelCard.vue?vue&type=style&index=0&id=0a54d0d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a54d0d3",
  null
  
)

export default component.exports